export const walletReportsConfig = {
  title: "Wallet Reports",
  breadcrumbIcon: "ph-duotone ph-wallet",
  breadcrumbParent: "Reports",
  showDateFilter: true,
  idField: "id",
  defaultItemsPerPage: 10,
  defaultSortField: "created_at",
  defaultSortDirection: "desc",

 numericFields: [
  "Amount",
  "Commission", "TDS", "Charge",
  "Opening Balance", "Closing balance",
  "SDOpening Balance", "SDCommission", "SDTDS", "SDCharge", "SDClosing balance",
  "DOpening Balance",  "DCommission",  "DTDS",  "DCharge",  "DClosing balance",
  "Opening Balance BC", "Closing Balance BC",
  "BC Commission", "BC TDS", "BC Charge",
  "Opening Balance MAdmin", "Closing balance MAdmin",
  "Opening Balance Admin",  "Closing Balance Admin",
  "ACommission", "ACharge", "AGST",
],

  columns: [
    // Identifiers
    { key: "id", label: "ID", type: "text", sortable: true },
    { key: "REF No", label: "Ref No", type: "text", sortable: true },
    { key: "ACK NO", label: "ACK No", type: "text" },
    { key: "TXN ID", label: "TXN ID", type: "text" },
    { key: "order_id", label: "Order ID", type: "text"  },
  { key: "product", label: "Product", type: "text"  },
  { key: "amount", label: "Amount", type: "text"  },
  { key: "status", label: "Status", type: "text"  },
  { key: "type", label: "Type" , type: "text" },

  { key: "opening_balance", label: "Opening Balance" },
  { key: "closing_balance", label: "Closing Balance" },

  { key: "commission", label: "Commission" },
  { key: "tds", label: "TDS" },
  { key: "charge", label: "Charge" },

  { key: "txn_id", label: "Transaction ID" },
  { key: "Transection Flow", label: "Transaction Flow" },
    // BC / User Info
    { key: "BC Name", label: "BC Name", type: "text", className: "f-w-500 text-dark" },
    { key: "BC_ID", label: "BC ID", type: "text" },
    { key: "Customer No", label: "Customer No", type: "text" },

    // Transaction Info
    { key: "Product", label: "Product", type: "text", className: "text-capitalize" },
    { key: "Transection Type", label: "Txn Type", type: "text" },
    { key: "TXN Flow", label: "Flow", type: "text" },
// Add these missing ones to the columns array:

{ key: "ID",                   label: "ID",                    type: "text", sortable: true },
{ key: "modified_at",          label: "Modified At",           type: "text" },
{ key: "Product Type",         label: "Product Type",          type: "text" },
{ key: "Opening Balance",      label: "Opening Balance",       type: "currency" },
{ key: "Closing balance",      label: "Closing Balance",       type: "currency" },  // ⚠️ lowercase 'b'

// Super Distributor
{ key: "SDOpening Balance",    label: "SD Opening Balance",    type: "currency" },
{ key: "SDCommission",         label: "SD Commission",         type: "currency" },
{ key: "SDTDS",                label: "SD TDS",                type: "currency" },
{ key: "SDCharge",             label: "SD Charge",             type: "currency" },
{ key: "SDClosing balance",    label: "SD Closing Balance",    type: "currency" },  // ⚠️ lowercase 'b'

// Distributor
{ key: "DOpening Balance",     label: "D Opening Balance",     type: "currency" },
{ key: "DCommission",          label: "D Commission",          type: "currency" },
{ key: "DTDS",                 label: "D TDS",                 type: "currency" },
{ key: "DCharge",              label: "D Charge",              type: "currency" },
{ key: "DClosing balance",     label: "D Closing Balance",     type: "currency" },  // ⚠️ lowercase 'b'

{ key: "TXN Date",             label: "TXN Date",              type: "text" },
{ key: "TXN Time",             label: "TXN Time",              type: "text" },
    // Amounts
    { key: "Amount", label: "Amount", type: "currency", sortable: true },
    { key: "Commission", label: "Commission", type: "currency" },
    { key: "Charge", label: "Charge", type: "currency" },
    { key: "TDS", label: "TDS", type: "currency" },

    // Main Admin
    { key: "Opening Balance MAdmin", label: "Opening Balance MAdmin", type: "currency" },
    { key: "Closing balance MAdmin", label: "Closing Balance MAdmin", type: "currency" },

    // Admin
    { key: "Opening Balance Admin", label: "Opening Balance Admin", type: "currency" },
    { key: "Closing Balance Admin", label: "Closing Balance Admin", type: "currency" },
    { key: "ACommission", label: "Admin Commission", type: "currency" },
    { key: "ACharge", label: "Admin Charge", type: "currency" },
    { key: "AGST", label: "Admin GST", type: "currency" },

    // BC
    { key: "Opening Balance BC", label: "Opening Balance BC", type: "currency" },
    { key: "Closing Balance BC", label: "Closing Balance BC", type: "currency" },
    { key: "BC Commission", label: "BC Commission", type: "currency" },
    { key: "BC TDS", label: "BC TDS", type: "currency" },
    { key: "BC Charge", label: "BC Charge", type: "currency" },

    // Bank / Identity
    { key: "bank_rrn", label: "Bank RRN", type: "text" },
    { key: "aadhar_number", label: "Aadhar No", type: "text" },

    // Status
    {
      key: "Status",
      label: "Status",
      type: "badge",
      sortable: true,
      badgeClass: (value) => {
        const map = {
          success: "badge bg-success",
          pending: "badge bg-warning",
          failed: "badge bg-danger",
          processing: "badge bg-primary",
        };
        return map[value?.toLowerCase()] || "badge bg-secondary";
      },
      transform: (value) => value?.toUpperCase(),
    },

    // Dates
    { key: "created_at", label: "Date & Time", type: "text", sortable: true },
    { key: "TXN Date", label: "TXN Date", type: "text" },
    { key: "TXN Time", label: "TXN Time", type: "text" },
    { key: "modified_at", label: "Modified At", type: "text" },

    // Admin Name
    { key: "Admin", label: "Admin", type: "text" },
  ],

  filters: [
    { key: "Status", label: "Status", width: "150px" },
    { key: "Product", label: "Product", width: "150px" },
    { key: "TXN Flow", label: "Flow", width: "150px" },
  ],

  actions: {
    view: true,
    edit: false,
    delete: false,
    export: true,
  },
};

// ─────────────────────────────────────────────────────────────────────────────
// Add this object to your  config/tableConfigs.js  (or tableConfigs.ts)
// alongside creditDebitReportsConfig, rechargeReportsConfig, etc.
//
// Every key that the API can return is listed here.
// The page component filters down to role-appropriate columns at runtime.
// ─────────────────────────────────────────────────────────────────────────────

// ─────────────────────────────────────────────────────────────────────────────
// dayWiseUserReportConfig
// Add to: config/tableConfigs.js
//
// This report covers fund_transfer + credit_debit products only.
// No commission / TDS / GST columns — those products don't earn commission.
// Only opening balance, amount, closing balance are meaningful.
// ─────────────────────────────────────────────────────────────────────────────

export const ExtraServiceManagementConfig = {
  title: "Extra Service Management",
  breadcrumbIcon: "ph-duotone ph-squares-four",
  breadcrumbParent: "Services",
  showDateFilter: false,
  idField: "id",
  defaultItemsPerPage: 10,
  defaultSortField: "id",
  defaultSortDirection: "desc",

  columns: [
    { key: "id", label: "ID", type: "text", sortable: true },
    { key: "Name", label: "Name", type: "text", sortable: true, className: "f-w-500 text-dark" },
    { key: "Category", label: "Category", type: "text", sortable: true },
   
    {
      key: "Image",
      label: "Image",
      type: "image",
      sortable: true
    },
    { key: "Material Click", label: "Material Click", type: "text" },
    { key: "Web URL", label: "Web URL", type: "text" },
    {
      key: "Status",
      label: "Status",
      type: "badge",
      sortable: true,
      badgeClass: (value) => (value ? "badge bg-success" : "badge bg-secondary"),
      transform: (value) => (value ? "ACTIVE" : "INACTIVE"),
    },
  ],

  filters: [
    { key: "Category", label: "Category", width: "150px" },
    { key: "Status", label: "Status", width: "150px" },
  ],

  actions: {
    view: true,
    edit: true,
    delete: true,
    export: true,
  },
};

export const dayWiseUserReportConfig = {
  title:         "Day-wise User Report",
  apiKey:        "data",
  dateFilterKey: "filter_date",
  endDateKey:    "end_date",
  defaultSort:   "txn_date",
  defaultSortDir:"desc",

  // Extra root keys the hook should forward beyond `data`
  extraKeys: ["day_wise_summary", "service_totals", "grand_totals", "pagination", "role"],

  columns: [

    // ── Identity ─────────────────────────────────────────────────────────────
    { key: "id",         label: "ID",         sortable: true,  width: 70  },
    { key: "ref_no",     label: "Ref No",     sortable: false, width: 130, mono: true },
    { key: "ack_no",     label: "Ack No",     sortable: false, width: 130, mono: true },
    { key: "api_txn_id", label: "API Txn ID", sortable: false, width: 140, mono: true },
    { key: "bank_rrn",   label: "Bank RRN",   sortable: false, width: 130, mono: true },

    // ── Date / time ───────────────────────────────────────────────────────────
    { key: "created_at", label: "Date & Time", sortable: true,  width: 160 },
    { key: "txn_date",   label: "Txn Date",    sortable: true,  width: 100 },
    { key: "txn_time",   label: "Txn Time",    sortable: false, width: 90  },

    // ── BC (Retailer) info ────────────────────────────────────────────────────
    { key: "bc_id",    label: "BC ID",    sortable: true,  width: 70  },
    { key: "bc_name",  label: "BC Name",  sortable: true,  width: 140 },
    { key: "bc_phone", label: "BC Phone", sortable: false, width: 120, mono: true },

    // ── Transaction details ───────────────────────────────────────────────────
    { key: "service",  label: "Service",  sortable: true,  width: 120, type: "badge"    },
    { key: "txn_flow", label: "Txn Flow", sortable: false, width: 160                   },
    { key: "amount",   label: "Amount",   sortable: true,  width: 110, type: "currency" },
    { key: "status",   label: "Status",   sortable: true,  width: 100, type: "status"   },
    { key: "remark",   label: "Remark",   sortable: false, width: 180                   },

    // ── BC (Retailer) opening / closing ────────────────────────────────────────
    { key: "Opening Balance BC", label: "Opening Bal BC", sortable: false, width: 130, type: "currency" },
    { key: "Closing Balance BC", label: "Closing Bal BC", sortable: false, width: 130, type: "currency" },

    // ── Distributor opening / closing ─────────────────────────────────────────
    { key: "Opening Balance Dist", label: "Opening Bal Dist", sortable: false, width: 140, type: "currency" },
    { key: "Closing Balance Dist", label: "Closing Bal Dist", sortable: false, width: 140, type: "currency" },

    // ── Master Distributor opening / closing ──────────────────────────────────
    { key: "Opening Balance MD", label: "Opening Bal MD", sortable: false, width: 130, type: "currency" },
    { key: "Closing Balance MD", label: "Closing Bal MD", sortable: false, width: 130, type: "currency" },

    // ── White Label opening / closing ─────────────────────────────────────────
    { key: "Opening Balance WL", label: "Opening Bal WL", sortable: false, width: 130, type: "currency" },
    { key: "Closing Balance WL", label: "Closing Bal WL", sortable: false, width: 130, type: "currency" },

    // ── Admin opening / closing ───────────────────────────────────────────────
    { key: "Opening Balance Admin", label: "Opening Bal Admin", sortable: false, width: 140, type: "currency" },
    { key: "Closing Balance Admin", label: "Closing Bal Admin", sortable: false, width: 140, type: "currency" },

    // ── Main Admin opening / closing ──────────────────────────────────────────
    { key: "Opening Balance MAdmin", label: "Opening Bal MAdmin", sortable: false, width: 150, type: "currency" },
    { key: "Closing Balance MAdmin", label: "Closing Bal MAdmin", sortable: false, width: 150, type: "currency" },

    // ── Day-summary aggregated columns ────────────────────────────────────────
    { key: "total_txn",    label: "Total Txns",   sortable: true, width: 100                   },
    { key: "total_amount", label: "Total Amount", sortable: true, width: 130, type: "currency" },
  ],
};



export const WalletManagement = {
  title: "Wallet Load Requests",
  breadcrumbIcon: "ph-duotone ph-wallet",
  breadcrumbParent: "Wallet",
  showDateFilter: true,
  idField: "id",
  defaultItemsPerPage: 10,
  defaultSortField: "id",
  defaultSortDirection: "desc",

  numericFields: [
    "amount",
    "opening_balance",
    "closing_balance",
  ],
  listKey: "data",
  columns: [
    // Identifiers
    { key: "id", label: "ID", type: "text", sortable: true },
    { key: "ref_id", label: "Ref No", type: "text", sortable: true, className: "f-w-600" },
    
    // Requester Info (For Approvers)
    { key: "requester_phone", label: "Requester", type: "text", className: "f-w-500 text-dark" },
    { key: "requester_role", label: "Role", type: "text", transform: (val) => val?.replace(/_/g, ' ').toUpperCase() },
    
    // Target Info
    { 
      key: "target_label", 
      label: "Requested To", 
      type: "text",
      className: "text-primary f-w-500" 
    },

    // Transaction Details
    { key: "amount", label: "Amount", type: "currency", sortable: true },
    { key: "r_type", label: "Type", type: "text", transform: (val) => val === "main_admin_topup_request" ? "Top-up" : "Load" },
    
    // Balance Tracking
    { key: "opening_balance", label: "Opening Bal", type: "currency" },
    { key: "closing_balance", label: "Closing Bal", type: "currency" },

    // Remarks
    { key: "remark", label: "User Remark", type: "text" },
    { key: "description", label: "System Note", type: "text", className: "text-muted small" },

    // Status Badge
    {
      key: "status",
      label: "Status",
      type: "badge",
      sortable: true,
      badgeClass: (value) => {
        const val = value?.toLowerCase();
        if (val === "success" || val === "approve") return "badge bg-success";
        if (val === "pending") return "badge bg-warning text-dark";
        if (val === "failed" || val === "reject") return "badge bg-danger";
        return "badge bg-secondary";
      },
      transform: (value) => {
        const val = value?.toLowerCase();
        if (val === "success" || val === "approve") return "APPROVED";
        if (val === "failed" || val === "reject") return "REJECTED";
        return value?.toUpperCase();
      },
    },

    // Date
    { key: "created_at", label: "Date & Time", type: "text", sortable: true },
  ],

  filters: [
    { key: "status", label: "Status", width: "150px" },
    { key: "r_type", label: "Request Type", width: "150px" },
  ],

  actions: {
    view: true,   // This will trigger the "Review" modal
    edit: false,
    delete: false,
    export: true,
  },
};

// ✅ AEPS CONFIG

export const BannerManagementConfig = {
  title: "Banner Management",
  apiUrl: "https://pro.mokshiq.in/banner_management",
  columns: [
    { key: "name",  label: "Banner Name" },           // ✅ GET returns "name"
    { key: "type",  label: "Type" },                  // ✅ GET returns "type"
     
      {
        key: "photo",
        label: "Logo",
        type: "image",
        sortable: true
      }
  ],
  actions: ["view", "edit", "delete"],
};

export const aepsReportsConfig = {
  title: "AEPS Reports",
  idField: "id",
  actions: { view: true, edit: false, delete: false },

  columns: [
    { key: "id", label: "ID" },
    { key: "refNo", label: "Ref No", type: "link" },
    { key: "ackNo", label: "Ack No" },
    { key: "productType", label: "Txn Type" },
    { key: "product", label: "Product" },
    { key: "amount", label: "Amount", type: "currency" },
    { key: "bankName", label: "Bank" },
    { key: "status", label: "Status", type: "badge",
      badgeClass: (v) => v === "success" ? "bg-success" : "bg-danger"
    },
    { key: "createdAt", label: "Date" },
    { key: "customerNo", label: "Customer No" },
    { key: "walletTxn", label: "Wallet Txn" },
    { key: "txnFlow", label: "Txn Flow" },
    { key: "bankRrn", label: "Bank RRN" },
    { key: "aadharNumber", label: "Aadhar" },
    { key: "description", label: "Description" },

    // Admin Wallet
    { key: "openingBalanceAdmin", label: "Open Bal (Admin)", type: "currency" },
    { key: "commissionAdmin", label: "Commission (Admin)", type: "currency" },
    { key: "tdsAdmin", label: "TDS (Admin)", type: "currency" },
    { key: "chargeAdmin", label: "Charge (Admin)", type: "currency" },
    { key: "gstAdmin", label: "GST (Admin)", type: "currency" },
    { key: "closingBalanceAdmin", label: "Close Bal (Admin)", type: "currency" },

    // BC Wallet
    { key: "openingBalanceBc", label: "Open Bal (BC)", type: "currency" },
    { key: "bcCommission", label: "Commission (BC)", type: "currency" },
    { key: "bcTds", label: "TDS (BC)", type: "currency" },
    { key: "bcCharge", label: "Charge (BC)", type: "currency" },
    { key: "bcGst", label: "GST (BC)", type: "currency" },
    { key: "closingBalanceBc", label: "Close Bal (BC)", type: "currency" },

    // Main Admin Wallet
    { key: "openingBalanceMAdmin", label: "Open Bal (MAdmin)", type: "currency" },
    { key: "commissionMAdmin", label: "Commission (MAdmin)", type: "currency" },
    { key: "tdsMAdmin", label: "TDS (MAdmin)", type: "currency" },
    { key: "chargeMAdmin", label: "Charge (MAdmin)", type: "currency" },
    { key: "closingBalanceMAdmin", label: "Close Bal (MAdmin)", type: "currency" }
  ]
};

export const moneyTransferReportsConfig = {
  title: "Money Transfer Reports",
  breadcrumbParent: "Reports",
  showDateFilter: true,

  idField: "id",
  defaultItemsPerPage: 10,

  numericFields: [
    "amount",

    // Retailer
    "openingBalanceBc",
    "bcCommission",
    "bcTds",
    "bcCharge",
    "bcGst",
    "closingBalanceBc",

    // Distributor
    "openingBalanceDistributor",
    "commission",
    "tds",
    "charge",
    "gst",
    "closingBalanceDistributor",

    // Super Distributor
    "openingBalanceSuperDistributor",
    "closingBalanceSuperDistributor",

    // Admin
    "openingBalanceAdmin",
    "commissionAdmin",
    "tdsAdmin",
    "chargeAdmin",
    "gstAdmin",
    "closingBalanceAdmin",

    // Main Admin
    "openingBalanceMAdmin",
    "commissionMAdmin",
    "tdsMAdmin",
    "chargeMAdmin",
    "closingBalanceMAdmin"
  ],

  columns: [
    // ===== COMMON =====
    { key: "id", label: "ID" },
    { key: "refNo", label: "Ref No" },
    { key: "ackNo", label: "ACK No" },
    { key: "transectionType", label: "Txn Type" },
    { key: "product", label: "Product" },
    { key: "number", label: "Customer No" },
    { key: "amount", label: "Amount", type: "currency" },
    {
  key: "status",
  label: "Status",
  type: "badge",
  sortable: true,
  badgeClass: (v) => {
    const map = {
      success: "badge bg-success",
      failed: "badge bg-danger",
      pending: "badge bg-warning",
      processing: "badge bg-info",
      reversed: "badge bg-dark"
    };

    return map[v?.toLowerCase()] || "badge bg-secondary";
  },
  transform: (v) => v?.toUpperCase(),
},

    { key: "createdAt", label: "Date" },

    // ===== RETAILER =====
    { key: "openingBalanceBc", label: "Opening Balance BC", type: "currency" },
    { key: "bcCommission", label: "BC Commission", type: "currency" },
    { key: "bcTds", label: "BC TDS", type: "currency" },
    { key: "bcCharge", label: "BC Charge", type: "currency" },
    { key: "bcGst", label: "BC GST", type: "currency" },
    { key: "closingBalanceBc", label: "Closing Balance BC", type: "currency" },

    // ===== DISTRIBUTOR =====
    { key: "openingBalanceDistributor", label: "Opening Balance (Dist.)", type: "currency" },
    { key: "closingBalanceDistributor", label: "Closing Balance (Dist.)", type: "currency" },

    // ===== SUPER DISTRIBUTOR =====
    { key: "openingBalanceSuperDistributor", label: "Opening Balance (SD)", type: "currency" },
    { key: "closingBalanceSuperDistributor", label: "Closing Balance (SD)", type: "currency" },

    // ===== ADMIN =====
    { key: "bcName", label: "BC Name" },

    { key: "openingBalanceAdmin", label: "Opening Balance Admin", type: "currency" },
    { key: "commissionAdmin", label: "Admin Commission", type: "currency" },
    { key: "tdsAdmin", label: "Admin TDS", type: "currency" },
    { key: "chargeAdmin", label: "Admin Charge", type: "currency" },
    { key: "gstAdmin", label: "Admin GST", type: "currency" },
    { key: "closingBalanceAdmin", label: "Closing Balance Admin", type: "currency" },

    { key: "walletTxn", label: "Wallet Txn" },
    { key: "txnFlow", label: "Txn Flow" },

    // ===== MAIN ADMIN =====
    { key: "openingBalanceMAdmin", label: "Opening Balance Main Admin", type: "currency" },
    { key: "commissionMAdmin", label: "Main Admin Commission", type: "currency" },
    { key: "tdsMAdmin", label: "Main Admin TDS", type: "currency" },
    { key: "chargeMAdmin", label: "Main Admin Charge", type: "currency" },
    { key: "closingBalanceMAdmin", label: "Closing Balance Main Admin", type: "currency" },

    // ===== MISC =====
    { key: "bankRrn", label: "Bank RRN" },
    { key: "aadharNumber", label: "Aadhaar / Card No" }
  ],

  actions: { view: false, edit: false, delete: false },
  filters: [
  { key: "status", label: "Status", width: "140px" },
  { key: "product", label: "Product", width: "160px" },
],

};
export const intraWalletReportConfig = {
  title: "IntraWallet Transfer Reports",
  breadcrumbParent: "Reports",
  showDateFilter: true,

  idField: "id",
  defaultItemsPerPage: 10,

  safe: (value, currency = false) => {
    if (value === null || value === undefined) {
      return currency ? "0.00" : "";
    }

    const n = Number(value);
    if (currency) {
      return isNaN(n) ? "0.00" : n.toFixed(2);
    }

    return value;
  },

  numericFields: [
    "amount",

    // Retailer
    "Opening Balance",
    "Commission",
    "TDS",
    "Charge",
    "GST",
    "Closing Balance",

    // Distributor
    "Opening Balance Dist",
    "Commission Dist",
    "TDS Dist",
    "Charge Dist",
    "GST Dist",
    "Closing Balance Dist",

    // Super Distributor
    "Opening Balance SuperDist",
    "Commission SuperDist",
    "TDS SuperDist",
    "Charge SuperDist",
    "GST SuperDist",
    "Closing Balance SuperDist",

    // Admin
    "Opening Balance Admin",
    "Closing Balance Admin",

    // Main Admin
    "Opening Balance MAdmin",
    "Commission MAdmin",
    "TDS MAdmin",
    "Charge MAdmin",
    "Closing Balance MAdmin",
  ],

  columns: [
    { key: "id", label: "ID", sortable: true },
    { key: "ref_no", label: "Ref No" },
    { key: "ack_no", label: "ACK No" },
    { key: "transection_type", label: "Txn Type" },
    { key: "product", label: "Product" },
    { key: "sender_phone", label: "Sender Phone" },
    { key: "receiver_phone", label: "Receiver Phone" },
    { key: "sender_name", label: "Sender Name" },
    { key: "receiver_name", label: "Receiver Name" },
    { key: "number", label: "Customer No" },

    { key: "amount", label: "Amount", type: "currency", sortable: true },

    {
      key: "status",
      label: "Status",
      type: "badge",
      sortable: true,
      badgeClass: (v) => {
        const map = {
          success: "badge bg-success",
          failed: "badge bg-danger",
          pending: "badge bg-warning",
          processing: "badge bg-info",
        };
        return map[v?.toLowerCase()] || "badge bg-secondary";
      },
      transform: (v) => v?.toUpperCase(),
    },

    { key: "created_at", label: "Date", sortable: true },

    // ===== RETAILER =====
    { key: "Opening Balance", label: "Opening Balance", type: "currency" },
    { key: "Commission", label: "Commission", type: "currency" },
    { key: "TDS", label: "TDS", type: "currency" },
    { key: "Charge", label: "Charge", type: "currency" },
    { key: "GST", label: "GST", type: "currency" },
    { key: "Closing Balance", label: "Closing Balance", type: "currency" },

    // ===== DISTRIBUTOR =====
    { key: "Opening Balance Dist", label: "Opening Balance (Dist)", type: "currency" },
    { key: "Commission Dist", label: "Commission (Dist)", type: "currency" },
    { key: "TDS Dist", label: "TDS (Dist)", type: "currency" },
    { key: "Charge Dist", label: "Charge (Dist)", type: "currency" },
    { key: "GST Dist", label: "GST (Dist)", type: "currency" },
    { key: "Closing Balance Dist", label: "Closing Balance (Dist)", type: "currency" },

    // ===== SUPER DISTRIBUTOR =====
    { key: "Opening Balance SuperDist", label: "Opening Balance (SD)", type: "currency" },
    { key: "Commission SuperDist", label: "Commission (SD)", type: "currency" },
    { key: "TDS SuperDist", label: "TDS (SD)", type: "currency" },
    { key: "Charge SuperDist", label: "Charge (SD)", type: "currency" },
    { key: "GST SuperDist", label: "GST (SD)", type: "currency" },
    { key: "Closing Balance SuperDist", label: "Closing Balance (SD)", type: "currency" },

    // ===== ADMIN =====
    { key: "BC Name", label: "BC Name" },
    { key: "Opening Balance Admin", label: "Opening Balance Admin", type: "currency" },
    { key: "Closing Balance Admin", label: "Closing Balance Admin", type: "currency" },

    // ===== MAIN ADMIN =====
    { key: "Opening Balance MAdmin", label: "Opening Balance MAdmin", type: "currency" },
    { key: "Commission MAdmin", label: "Commission MAdmin", type: "currency" },
    { key: "TDS MAdmin", label: "TDS MAdmin", type: "currency" },
    { key: "Charge MAdmin", label: "Charge MAdmin", type: "currency" },
    { key: "Closing Balance MAdmin", label: "Closing Balance MAdmin", type: "currency" },

    { key: "Wallet Txn", label: "Wallet Txn" },
    { key: "TXN Flow", label: "Txn Flow" },
    { key: "bank_rrn", label: "Bank RRN" },
    { key: "card_number", label: "Aadhaar / Card No" },
  ],

  filters: [
    { key: "status", label: "Status", width: "140px" },
    { key: "product", label: "Product", width: "160px" },
  ],

  actions: { view: false, edit: false, delete: false },
};


export const bcWalletReportConfig = {
  title: "BC Wallet Report",
  breadcrumbParent: "Reports",
  showDateFilter: false,

  idField: "BC_ID",
  defaultItemsPerPage: 10,

  safe: (value, currency = false) => {
    if (value === null || value === undefined) {
      return currency ? "0.00" : "";
    }

    const n = Number(value);
    if (currency) {
      return isNaN(n) ? "0.00" : n.toFixed(2);
    }

    return value;
  },

  numericFields: [
    "Wallet Balance",
    "amount",
    "commission",
    "tds",
  ],

  columns: [
    { key: "BC_ID", label: "BC ID", sortable: true },
    { key: "Admin  Name", label: "Admin Name" },
    { key: "Admin Name", label: "Admin Name" },
    { key: "Mobile", label: "Mobile" },
    { key: "Role", label: "Role" },
    { key: "Wallet Balance", label: "Wallet Balance", type: "currency" },

    { key: "Instant Pay Onboarding", label: "Instant Pay" },
    { key: "Eko Onboarding", label: "Eko" },
    { key: "Iserveu Onboarding", label: "Iserveu" },

    // Distributor / SD keys
    { key: "id", label: "ID" },
    { key: "ref_no", label: "Ref No" },
    { key: "ack_no", label: "ACK No" },
    { key: "transection_type", label: "Txn Type" },
    { key: "product", label: "Product" },
    { key: "number", label: "Customer No" },
    { key: "amount", label: "Amount", type: "currency" },
    {
      key: "status",
      label: "Status",
      type: "badge",
      badgeClass: (v) => {
        const map = {
          success: "badge bg-success",
          failed: "badge bg-danger",
          pending: "badge bg-warning",
        };
        return map[v?.toLowerCase()] || "badge bg-secondary";
      },
      transform: (v) => v?.toUpperCase(),
    },
    { key: "commission", label: "Commission", type: "currency" },
    { key: "tds", label: "TDS", type: "currency" },
    { key: "bank_rrn", label: "Bank RRN" },
    { key: "aadhar_number", label: "Aadhaar No" },
  ],

  actions: { view: false, edit: false, delete: false },
};

export const creditDebitReportsConfig = {
  title: "Credit / Debit Reports",
  breadcrumbParent: "Reports",
  showDateFilter: true,

  idField: "id",
  defaultItemsPerPage: 10,

  safe: (value, currency = false) => {
    if (value === null || value === undefined) {
      return currency ? "0.00" : "";
    }
    const n = Number(value);
    if (currency) return isNaN(n) ? "0.00" : n.toFixed(2);
    return value;
  },

  numericFields: [
    "amount",
    "Amount",

    // Retailer / BC
    "Opening Balance BC",
    "BC Commission",
    "BC TDS",
    "BC Charge",
    "BC GST",
    "Closing Balance BC",

    // Distributor
    "Opening Balance Dist",
    "Commission Dist",
    "TDS Dist",
    "Charge Dist",
    "GST Dist",
    "Closing Balance Dist",

    // Master Distributor / Super Dist
    "Opening Balance SuperDist",
    "Commission SuperDist",
    "TDS SuperDist",
    "Charge SuperDist",
    "GST SuperDist",
    "Closing Balance SuperDist",

    // White Label
    "Opening Balance WL",
    "Commission WL",
    "TDS WL",
    "Charge WL",
    "GST WL",
    "Closing Balance WL",

    // Admin
    "Opening Balance Admin",
    "Commission",
    "TDS",
    "Charge",
    "GST",
    "Closing Balance Admin",

    // Main Admin
    "Opening Balance MAdmin",
    "Commission MAdmin",
    "TDS MAdmin",
    "Charge MAdmin",
    "Closing Balance MAdmin",
  ],

  columns: [

    // ── COMMON ───────────────────────────────────────────────────────────────
    { key: "id",               label: "ID" },
    { key: "ID",               label: "ID" },           // Admin / Main Admin mapper key
    { key: "ref_no",           label: "Ref No" },
    { key: "REF No",           label: "Ref No" },       // Admin / Main Admin mapper key
    { key: "ack_no",           label: "ACK No" },
    { key: "ACK NO",           label: "ACK No" },       // Admin / Main Admin mapper key
    { key: "transection_type", label: "Txn Type" },
    { key: "Product Type",     label: "Txn Type" },     // Admin / Main Admin mapper key
    { key: "product",          label: "Product" },
    { key: "Product",          label: "Product" },      // Admin / Main Admin mapper key
    { key: "amount",           label: "Amount",         type: "currency" },
    { key: "Amount",           label: "Amount",         type: "currency" }, // Admin mapper key
    { key: "number",           label: "Customer No" },
    { key: "Customer No",      label: "Customer No" },  // Admin mapper key
    { key: "receiver_phone",   label: "Receiver" },
    { key: "sender_phone",     label: "Sender" },
    { key: "sender_name",      label: "Sender Name" },
    { key: "receiver_name",    label: "Receiver Name" },
    { key: "BC Name",          label: "BC Name" },      // Admin / Main Admin
    { key: "remark",           label: "Remark" },
    { key: "created_at",       label: "Date" },

    {
      key: "status",
      label: "Status",
      type: "badge",
      badgeClass: (v) => {
        const map = {
          success: "badge bg-success",
          failed:  "badge bg-danger",
          pending: "badge bg-warning",
        };
        return map[v?.toLowerCase()] || "badge bg-secondary";
      },
      transform: (v) => v?.toUpperCase(),
    },
    {
      key: "Status",            // Admin / Main Admin mapper key
      label: "Status",
      type: "badge",
      badgeClass: (v) => {
        const map = {
          success: "badge bg-success",
          failed:  "badge bg-danger",
          pending: "badge bg-warning",
        };
        return map[v?.toLowerCase()] || "badge bg-secondary";
      },
      transform: (v) => v?.toUpperCase(),
    },

    // ── RETAILER / BC ─────────────────────────────────────────────────────────
    { key: "Opening Balance BC",  label: "Opening Bal BC",  type: "currency" },
    { key: "BC Commission",       label: "BC Commission",   type: "currency" },
    { key: "BC TDS",              label: "BC TDS",          type: "currency" },
    { key: "BC Charge",           label: "BC Charge",       type: "currency" },
    { key: "BC GST",              label: "BC GST",          type: "currency" },
    { key: "Closing Balance BC",  label: "Closing Bal BC",  type: "currency" },

    // ── DISTRIBUTOR ───────────────────────────────────────────────────────────
    { key: "Opening Balance Dist",  label: "Opening Bal Dist",  type: "currency" },
    { key: "Commission Dist",       label: "Commission Dist",   type: "currency" },
    { key: "TDS Dist",              label: "TDS Dist",          type: "currency" },
    { key: "Charge Dist",           label: "Charge Dist",       type: "currency" },
    { key: "GST Dist",              label: "GST Dist",          type: "currency" },
    { key: "Closing Balance Dist",  label: "Closing Bal Dist",  type: "currency" },

    // ── MASTER DISTRIBUTOR / SUPER DIST ───────────────────────────────────────
    { key: "Opening Balance SuperDist",  label: "Opening Bal SD",  type: "currency" },
    { key: "Commission SuperDist",       label: "Commission SD",   type: "currency" },
    { key: "TDS SuperDist",              label: "TDS SD",          type: "currency" },
    { key: "Charge SuperDist",           label: "Charge SD",       type: "currency" },
    { key: "GST SuperDist",              label: "GST SD",          type: "currency" },
    { key: "Closing Balance SuperDist",  label: "Closing Bal SD",  type: "currency" },

    // ── WHITE LABEL ───────────────────────────────────────────────────────────
    { key: "Opening Balance WL",  label: "Opening Bal WL",  type: "currency" },
    { key: "Commission WL",       label: "Commission WL",   type: "currency" },
    { key: "TDS WL",              label: "TDS WL",          type: "currency" },
    { key: "Charge WL",           label: "Charge WL",       type: "currency" },
    { key: "GST WL",              label: "GST WL",          type: "currency" },
    { key: "Closing Balance WL",  label: "Closing Bal WL",  type: "currency" },

    // ── ADMIN ─────────────────────────────────────────────────────────────────
    { key: "Opening Balance Admin",  label: "Opening Bal Admin",  type: "currency" },
    { key: "Commission",             label: "Commission",         type: "currency" },
    { key: "TDS",                    label: "TDS",                type: "currency" },
    { key: "Charge",                 label: "Charge",             type: "currency" },
    { key: "GST",                    label: "GST",                type: "currency" },
    { key: "Closing Balance Admin",  label: "Closing Bal Admin",  type: "currency" },

    // ── MAIN ADMIN ────────────────────────────────────────────────────────────
    { key: "Opening Balance MAdmin",  label: "Opening Bal MAdmin",  type: "currency" },
    { key: "Commission MAdmin",       label: "Commission MAdmin",   type: "currency" },
    { key: "TDS MAdmin",              label: "TDS MAdmin",          type: "currency" },
    { key: "Charge MAdmin",           label: "Charge MAdmin",       type: "currency" },
    { key: "Closing Balance MAdmin",  label: "Closing Bal MAdmin",  type: "currency" },
    { key: "Admin",                   label: "Admin" },             // Main Admin only

    // ── MISC ──────────────────────────────────────────────────────────────────
    { key: "Wallet Txn",   label: "Wallet Txn" },
    { key: "TXN Flow",     label: "Txn Flow" },
    { key: "bank_rrn",     label: "Bank RRN" },
    { key: "card_number",  label: "Aadhaar / Card No" },
  ],

  actions: { view: false, edit: false, delete: false },
};

export const walletSettlementReportsConfig = {
  title: "Payout Reports",
  breadcrumbIcon: "ph-duotone ph-wallet",
  breadcrumbParent: "Reports",
  showDateFilter: true,

  idField: "id",
  defaultItemsPerPage: 10,

  safe: (value, currency = false) => {
    if (value === null || value === undefined) return currency ? "0.00" : "";
    const n = parseFloat(value);
    if (currency) return isNaN(n) ? "0.00" : n.toFixed(2);
    return value;
  },

  numericFields: [
    "amount",
    "Opening Balance",
    "Commission",
    "TDS",
    "Charge",
    "GST",
    "Closing Balance",
    "openingBalanceDistributor",
    "commission",
    "tds",
    "charge",
    "gst",
    "closingBalanceDistributor",
    "openingBalanceSuperDistributor",
    "closingBalanceSuperDistributor",
    "openingBalanceAdmin",
    "commissionAdmin",
    "tdsAdmin",
    "chargeAdmin",
    "gstAdmin",
    "closingBalanceAdmin",
    "openingBalanceMAdmin",
    "commissionMAdmin",
    "tdsMAdmin",
    "chargeMAdmin",
    "closingBalanceMAdmin"
  ],

  columns: [
    { key: "id", label: "ID", sortable: true },
    { key: "ref_no", label: "Ref No", sortable: true },
    { key: "ack_no", label: "ACK No", sortable: true },
    { key: "created_at", label: "Date", sortable: true },
    { key: "product", label: "Product", sortable: true },
    { key: "account_number", label: "Account No", sortable: true },
    { key: "holder_name", label: "Account Holder", sortable: true },
    { key: "number", label: "Mobile No", sortable: true },
    { key: "amount", label: "Amount", type: "currency", sortable: true },
    {
      key: "status",
      label: "Status",
      type: "badge",
      sortable: true,
      badgeClass: (v) => {
        const s = (v || "").toString().toLowerCase().trim();
        if (s === "success" || s === "accepted" || s === "successful") return "bg-success";
        if (s === "pending" || s === "processing" || s === "in_process") return "bg-warning";
        return "bg-danger";
      },
      transform: (v) => (v ? v.toString().toUpperCase() : "FAILED")
    },
    { key: "Opening Balance", label: "Opening Balance", type: "currency", sortable: true },
    { key: "Commission", label: "Commission", type: "currency", sortable: true },
    { key: "TDS", label: "TDS", type: "currency", sortable: true },
    { key: "Charge", label: "Charge", type: "currency", sortable: true },
    { key: "GST", label: "GST", type: "currency", sortable: true },
    { key: "Closing Balance", label: "Closing Balance", type: "currency", sortable: true },
    { key: "bank_rrn", label: "Bank RRN", sortable: true },

    // Fallbacks for BC / Distributor fields if present
    { key: "bcName", label: "BC Name" },
    { key: "openingBalanceDistributor", label: "Opening Balance (Dist.)", type: "currency" },
    { key: "commission", label: "Commission (Dist.)", type: "currency" },
    { key: "tds", label: "TDS (Dist.)", type: "currency" },
    { key: "charge", label: "Charge (Dist.)", type: "currency" },
    { key: "gst", label: "GST (Dist.)", type: "currency" },
    { key: "closingBalanceDistributor", label: "Closing Balance (Dist.)", type: "currency" },
    { key: "openingBalanceSuperDistributor", label: "Opening Balance (SD)", type: "currency" },
    { key: "closingBalanceSuperDistributor", label: "Closing Balance (SD)", type: "currency" },
    { key: "openingBalanceAdmin", label: "Opening Balance Admin", type: "currency" },
    { key: "commissionAdmin", label: "Admin Commission", type: "currency" },
    { key: "tdsAdmin", label: "Admin TDS", type: "currency" },
    { key: "chargeAdmin", label: "Admin Charge", type: "currency" },
    { key: "gstAdmin", label: "Admin GST", type: "currency" },
    { key: "closingBalanceAdmin", label: "Closing Balance Admin", type: "currency" },
    { key: "walletTxn", label: "Wallet Txn" },
    { key: "txnFlow", label: "Txn Flow" }
  ],

  filters: [
    { key: "status", label: "Status", width: "140px" },
    { key: "product", label: "Product", width: "160px" }
  ],

  actions: {
    view: true,
    edit: false,
    delete: false
  }
};

export const bbpsReportConfig = {
  title: "BBPS Reports",
  breadcrumbIcon: "ph-duotone ph-receipt",
  breadcrumbParent: "Reports",
  showDateFilter: true,

  idField: "id",
  defaultItemsPerPage: 10,

  safe: (value, currency = false) => {
    if (value === null || value === undefined) {
      return currency ? "0.00" : "";
    }

    const n = Number(value);
    if (currency) {
      return isNaN(n) ? "0.00" : n.toFixed(2);
    }

    return value;
  },

  numericFields: [
    "amount",

    "Opening Balance BC",
    "BC Commission",
    "Closing Balance BC",

    "commission Dist",
    "tds Dist",

    "commission SuperDist",
    "tds SuperDist",

    "Opening Balance Admin",
    "Commission Admin",
    "TDS Admin",
    "Charge Admin",
    "GST Admin",
    "Closing Balance Admin",

    "Opening Balance MAdmin",
    "Commission MAdmin",
    "Charge MAdmin",
    "TDS MAdmin",
    "Closing Balance MAdmin",
  ],

  columns: [
    { key: "id", label: "ID", sortable: true },

    { key: "txn_id", label: "Txn ID" },
    { key: "operator", label: "Operator" },
    { key: "product", label: "Product" },
    { key: "number", label: "Number" },

    { key: "amount", label: "Amount", type: "currency", sortable: true },

    { key: "created_at", label: "Date", sortable: true },

    {
      key: "status",
      label: "Status",
      type: "badge",
      sortable: true,
      badgeClass: (v) => {
        const map = {
          success: "badge bg-success",
          failed: "badge bg-danger",
          pending: "badge bg-warning",
        };
        return map[v?.toLowerCase()] || "badge bg-secondary";
      },
      transform: (v) => v?.toUpperCase(),
    },

    // ===== RETAILER =====
    { key: "Opening Balance BC", label: "Opening Balance BC", type: "currency" },
    { key: "BC Commission", label: "BC Commission", type: "currency" },
    { key: "tds", label: "TDS", type: "currency" },
    { key: "Closing Balance BC", label: "Closing Balance BC", type: "currency" },

    // ===== DISTRIBUTOR =====
    { key: "commission Dist", label: "Commission (Dist)", type: "currency" },
    { key: "tds Dist", label: "TDS (Dist)", type: "currency" },

    // ===== SUPER DISTRIBUTOR =====
    { key: "commission SuperDist", label: "Commission (SD)", type: "currency" },
    { key: "tds SuperDist", label: "TDS (SD)", type: "currency" },

    // ===== ADMIN =====
    { key: "BC Name", label: "BC Name" },
    { key: "Phone", label: "Phone" },

    { key: "Opening Balance Admin", label: "Opening Balance Admin", type: "currency" },
    { key: "Commission Admin", label: "Admin Commission", type: "currency" },
    { key: "TDS Admin", label: "Admin TDS", type: "currency" },
    { key: "Charge Admin", label: "Admin Charge", type: "currency" },
    { key: "GST Admin", label: "Admin GST", type: "currency" },
    { key: "Closing Balance Admin", label: "Closing Balance Admin", type: "currency" },

    { key: "Wallet Txn", label: "Wallet Txn" },
    { key: "TXN ID", label: "TXN ID" },
    { key: "Transection Flow", label: "Txn Flow" },

    // ===== MAIN ADMIN =====
    { key: "Opening Balance MAdmin", label: "Opening Balance Main Admin", type: "currency" },
    { key: "Commission MAdmin", label: "Commission Main Admin", type: "currency" },
    { key: "Charge MAdmin", label: "Charge Main Admin", type: "currency" },
    { key: "TDS MAdmin", label: "TDS Main Admin", type: "currency" },
    { key: "Closing Balance MAdmin", label: "Closing Balance Main Admin", type: "currency" },
  ],

  filters: [
    { key: "status", label: "Status", width: "140px" },
    { key: "product", label: "Product", width: "160px" },
  ],

  actions: {
    view: false,
    edit: false,
    delete: false,
  },
};

  
// src/config/tableConfigs.js
export const rechargeReportsConfig = {
  title: "Recharge Reports",
  breadcrumbIcon: "ph-duotone ph-wallet",
  breadcrumbParent: "Reports",
  showDateFilter: true,
  idField: "id",
  defaultItemsPerPage: 10,
  defaultSortField: "created_at",
  defaultSortDirection: "desc",

  // fields formatted as currency
  numericFields: [
  "amount",
  "Opening Balance BC",
  "Closing Balance BC",       // uppercase (Retailer)
  "Closing balance BC",       // ⚠️ lowercase (Admin/White Label) — add this
  "BC Commission",
  "BC TDS",
  "Opening Balance",
  "Closing Balance",
  "Opening Balance MAdmin",
  "Closing balance MAdmin",
  "Commission",
  "TDS",
  "Charge",
  "GST",
],

  // null-safe formatter
  safe: (value, isCurrency = false) => {
    if (value === null || value === undefined || value === "null") return isCurrency ? "0.00" : "";
    if (isCurrency) {
      const num = parseFloat(value);
      return isNaN(num) ? "0.00" : num.toFixed(2);
    }
    return value;
  },

  columns: [
    { key: "txn_id", label: "Ref No", type: "link", sortable: true },
    { key: "BC Name", label: "BC Name", type: "text" },
    { key: "Phone", label: "Phone", type: "text" },
    { key: "operator", label: "Operator", type: "text" },
    { key: "number", label: "Number", type: "text" },
    { key: "product", label: "Product", type: "text" },
    { key: "Opening Balance MAdmin", label: "Opening Balance", type: "currency", transform: (v, cfg) => cfg.safe(v, true) },
    { key: "Closing balance MAdmin", label: "Closing Balance", type: "currency", transform: (v, cfg) => cfg.safe(v, true) },
    
    {
      key: "r_type",
      label: "Transaction Type",
      type: "badge",
      badgeClass: (value) => {
        const classes = {
          debit: "badge text-outline-danger",
          credit: "badge text-outline-success",
          load_wallet: "badge text-outline-primary",
        };
        return classes[value?.toLowerCase()?.replace(" ", "_")] || "badge text-outline-secondary";
      },
      transform: (value) => value?.toUpperCase() || "",
    },

    {
      key: "amount",
      label: "Amount",
      type: "currency",
      sortable: true,
      transform: (v, cfg) => cfg.safe(v, true),
    },

    {
      key: "status",
      label: "Status",
      type: "badge",
      badgeClass: (value) => {
        const classes = {
          success: "badge bg-success",
          pending: "badge bg-warning",
          failed: "badge bg-danger",
          processing: "badge bg-primary",
        };
        return classes[value?.toLowerCase()] || "badge bg-secondary";
      },
      transform: (value) => value?.toUpperCase() || "",
    },

    { key: "Transection Flow", label: "Flow", type: "text" },
    { key: "created_at", label: "Date", type: "text", sortable: true },

    // === Retailer / API Partner ===
    { key: "Opening Balance BC", label: "Opening Balance BC", type: "currency", transform: (v, cfg) => cfg.safe(v, true) },
    { key: "BC Commission", label: "BC Commission", type: "currency", transform: (v, cfg) => cfg.safe(v, true) },
    { key: "BC TDS", label: "BC TDS", type: "currency", transform: (v, cfg) => cfg.safe(v, true) },
    { key: "Closing Balance BC", label: "Closing Balance BC", type: "currency", transform: (v, cfg) => cfg.safe(v, true) },
    { key: "Closing balance BC", label: "BC Closing Balance", type: "currency", transform: (v, cfg) => cfg.safe(v, true) },
    { key: "api_txn_id", label: "API TXN ID", type: "text" },

    // === Distributor ===
    { key: "commission", label: "Distributor Commission", type: "currency", transform: (v, cfg) => cfg.safe(v, true) },
    { key: "tds", label: "Distributor TDS", type: "currency", transform: (v, cfg) => cfg.safe(v, true) },

    // === Master Distributor ===
    { key: "s_profit", label: "MD Commission", type: "currency", transform: (v, cfg) => cfg.safe(v, true) },
    { key: "sdtds", label: "MD TDS", type: "currency", transform: (v, cfg) => cfg.safe(v, true) },

    // === Admin ===
    { key: "Opening Balance", label: "Admin Opening Balance", type: "currency", transform: (v, cfg) => cfg.safe(v, true) },
    { key: "Commission", label: "Admin Commission", type: "currency", transform: (v, cfg) => cfg.safe(v, true) },
    { key: "TDS", label: "Admin TDS", type: "currency", transform: (v, cfg) => cfg.safe(v, true) },
    { key: "Charge", label: "Admin Charge", type: "currency", transform: (v, cfg) => cfg.safe(v, true) },
    { key: "GST", label: "Admin GST", type: "currency", transform: (v, cfg) => cfg.safe(v, true) },
    { key: "Closing Balance", label: "Admin Closing Balance", type: "currency", transform: (v, cfg) => cfg.safe(v, true) },
    { key: "Wallet Txn", label: "Wallet Txn", type: "text" },
    { key: "TXN ID", label: "TXN ID", type: "text" },

    // === White Label ===
    { key: "waccount_balance", label: "WL Opening Balance", type: "currency", transform: (v, cfg) => cfg.safe(v, true) },
    { key: "w_profit", label: "WL Commission", type: "currency", transform: (v, cfg) => cfg.safe(v, true) },
    { key: "wtds", label: "WL TDS", type: "currency", transform: (v, cfg) => cfg.safe(v, true) },
    { key: "wcharge", label: "WL Charge", type: "currency", transform: (v, cfg) => cfg.safe(v, true) },
    { key: "wgst", label: "WL GST", type: "currency", transform: (v, cfg) => cfg.safe(v, true) },
    { key: "wclosing_balance", label: "WL Closing Balance", type: "currency", transform: (v, cfg) => cfg.safe(v, true) },

    // === Main Admin ===
    { key: "maccount_balance", label: "Main Admin Opening Balance", type: "currency", transform: (v, cfg) => cfg.safe(v, true) },
    { key: "m_profit", label: "Main Admin Commission", type: "currency", transform: (v, cfg) => cfg.safe(v, true) },
    { key: "mtds", label: "Main Admin TDS", type: "currency", transform: (v, cfg) => cfg.safe(v, true) },
    { key: "mcharge", label: "Main Admin Charge", type: "currency", transform: (v, cfg) => cfg.safe(v, true) },
    { key: "mclosing_balance", label: "Main Admin Closing Balance", type: "currency", transform: (v, cfg) => cfg.safe(v, true) },
    {
  key: "api_response",
  label: "API Response",
  type: "text",
  transform: (value) => {
    if (!value) return "";

    try {
      if (typeof value === "object") {
        return JSON.stringify(value, null, 2);
      }

      return value;
    } catch (e) {
      return "";
    }
  }
}
  ],

  filters: [
    { key: "product", label: "Product", width: "150px" },
    { key: "operator", label: "Operator", width: "150px" },
    { key: "status", label: "Status", width: "120px" },
  ],

  actions: { view: true, edit: false, delete: false },
};


  export const MemberManagement = {
    title: "Member Management",
    breadcrumbIcon: "ph-duotone ph-user",
    breadcrumbParent: "Acounts",
    showDateFilter: false,
    idField: "id", // or "REF No" if that's your unique identifier
    defaultItemsPerPage: 10,
    defaultSortField: "created_at",
    defaultSortDirection: "desc",
    numericFields: ["Amount"],
    
    columns: [
      {
        key: "id",
        label: "ID",
        type: "text",
        sortable: true
      },
      {
        key: "name",
        label: "Name",
        type: "link",
        sortable: true
      },
      {
        key: "Email",
        label: "Email",
        type: "text",
        className: "f-w-500 text-dark"
      },
      {
        key: "Phone",
        label: "Phone",
        type: "text",
        className: "f-w-500 text-dark text-capitalize"
      },
      {
        key: "Role",
        label: "Role Name",
        type: "badge",
        badgeClass: (value) => {
          const classes = {
            'retailer': 'badge text-outline-danger',
            'distributor': 'badge text-outline-success',
            'master distributor': 'badge text-outline-primary',
            'white label': 'badge text-outline-warning',
            'admin': 'badge text-outline-primary',
            'main admin': 'badge text-outline-primary',
            'api partner': 'badge text-outline-primary'
          };
          return classes[value?.toLowerCase().replace(' ', '_')] || 'badge text-outline-secondary';
        },
        transform: (value) => value?.toUpperCase()
      },
      {
        key: "wallet_amount",
        label: "Amount",
        type: "currency",
        sortable: true
      },
      {
        key: "upi_amount",
        label: "UPI Wallet",
        type: "currency",
        sortable: true
      },
      {
        key: "aeps_amount",
        label: "AEPS Wallet",
        type: "currency",
        sortable: true
      },
      {
        key: "created_at",
        label: "Registered On",
        type: "text",
        sortable: true,
        transform: (value) => {
          if (!value) return "—";
          const date = new Date(value);
          return date.toLocaleString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          });
        },
      },
     
    ],
    
    filters: [
      {
        key: "Role",
        label: "Products",
        width: "150px"
      },
      
    ],
    
    actions: {
      view: true,
      edit: true,
      delete: true
    }
  };

  

  export const SchemeManagement = {
    title: "Scheme Management",
    breadcrumbIcon: "ph-duotone ph-user",
    breadcrumbParent: "Resource",
    showDateFilter: false,
    idField: "id", // or "REF No" if that's your unique identifier
    defaultItemsPerPage: 10,
    defaultSortField: "created_at",
    defaultSortDirection: "desc",
    // numericFields: ["Amount"],
    
    columns: [
      {
        key: "id",
        label: "ID",
        type: "text",
        sortable: true
      },
      {
        key: "Name",
        label: "Name",
        type: "link",
        sortable: true
      },
      
      {
        key: "Type",
        label: "Scheme Type",
        type: "badge",
        badgeClass: (value) => {
          const classes = {
            'plan': 'badge text-outline-danger',
            'scheme': 'badge text-outline-success',
           
          };
          return classes[value?.toLowerCase().replace(' ', '_')] || 'badge text-outline-secondary';
        },
        transform: (value) => value?.toUpperCase()
      },
      {
        key: "Status",
        label: "Status",
        type: "badge",
        badgeClass: (value) => {
          if (value === true || value === "true" || value === 1) {
            return "badge bg-success";   // green
          }
          if (value === false || value === "false" || value === 0) {
            return "badge bg-danger";    // red
          }
          return "badge bg-secondary";   // default/unknown
        },
        transform: (value) => {
          if (value === true || value === "true" || value === 1) return "Active";
          if (value === false || value === "false" || value === 0) return "Inactive";
          return "Unknown";
        },
      }
      
      
      
     
    ],
    
    filters: [
      {
        key: "Type",
        label: "Scheme Type",
        width: "150px"
      },
      {
        key: "Status",
        label: "Status",
        width: "150px"
      },
    ],
    
    actions: {
      view: true,
      edit: true,
      delete: true
    }
  };
  export const UserRechargeCommission = {
    title: "Recharge & Bill Payment Commission",
    breadcrumbIcon: "ph-duotone ph-user",
    breadcrumbParent: "account",
    showDateFilter: false,
    idField: "id", // or "REF No" if that's your unique identifier
    defaultItemsPerPage: 10,
    defaultSortField: "created_at",
    defaultSortDirection: "desc",
    // numericFields: ["Amount"],
    
    columns: [
      {
        key: "name",
        label: "Name",
        type: "text",
        sortable: true
      },
      {
        key: "operator",
        label: "Operator",
        type: "text",
        sortable: true
      },
      
      {
        key: "type",
        label: "Type",
        type: "badge",
        badgeClass: (value) => {
          const classes = {
            'percent': 'badge text-outline-danger',
            'fixed': 'badge text-outline-success',
           
          };
          return classes[value?.toLowerCase().replace(' ', '_')] || 'badge text-outline-secondary';
        },
        transform: (value) => value?.toUpperCase()
      },
      {
        key: "commission",
        label: "Commission",
        type: "currency",
        sortable: true
      },
      
      
      
     
    ],
    
    filters: [
      {
        key: "name",
        label: "Name",
        width: "150px"
      },
      {
        key: "type",
        label: "Type",
        width: "150px"
      },
    ],
    
    actions: {
      view: false,
      edit: false,
      delete: false
    }
  };
  export const UserOtherCommission = {
    title: "Other Service Commission",
    breadcrumbIcon: "ph-duotone ph-user",
    breadcrumbParent: "account",
    showDateFilter: false,
    idField: "id", // or "REF No" if that's your unique identifier
    defaultItemsPerPage: 10,
    defaultSortField: "created_at",
    defaultSortDirection: "desc",
    // numericFields: ["Amount"],
    
    columns: [
      {
        key: "name",
        label: "Name",
        type: "text",
        sortable: true
      },
      {
        key: "start_slab",
        label: "Start Slab",
        type: "amount",
        sortable: true
      },
      {
        key: "end_slab",
        label: "End Slab",
        type: "amount",
        sortable: true
      },
      
      {
        key: "type",
        label: "Type",
        type: "badge",
        badgeClass: (value) => {
          const classes = {
            'percent': 'badge text-outline-danger',
            'fixed': 'badge text-outline-success',
           
          };
          return classes[value?.toLowerCase().replace(' ', '_')] || 'badge text-outline-secondary';
        },
        transform: (value) => value?.toUpperCase()
      },
      {
        key: "commission",
        label: "Commission",
        type: "currency",
        sortable: true
      },
      
      
      
     
    ],
    
    filters: [
      {
        key: "name",
        label: "Name",
        width: "150px"
      },
      {
        key: "type",
        label: "Type",
        width: "150px"
      },
    ],
    
    actions: {
      view: false,
      edit: false,
      delete: false
    }
  };
  export const LoadWalletManagement = {
    title: "Load Wallet Amount",
    breadcrumbIcon: "ph-duotone ph-user",
    breadcrumbParent: "Resource",
    showDateFilter: false,
    idField: "id", // or "REF No" if that's your unique identifier
    defaultItemsPerPage: 10,
    defaultSortField: "created_at",
    defaultSortDirection: "desc",
    // numericFields: ["Amount"],

    columns: [
      {
        key: "id",
        label: "ID",
        type: "text",
        sortable: true,
      },
      {
        key: "Name",
        label: "Name",
        type: "link",
        sortable: true,
      },

      {
        key: "Type",
        label: "Scheme Type",
        type: "badge",
        badgeClass: (value) => {
          const classes = {
            plan: "badge text-outline-danger",
            scheme: "badge text-outline-success",
          };
          return (
            classes[value?.toLowerCase().replace(" ", "_")] ||
            "badge text-outline-secondary"
          );
        },
        transform: (value) => value?.toUpperCase(),
      },
      {
        key: "Status",
        label: "Status",
        type: "badge",
        badgeClass: (value) => {
          if (value === true || value === "true" || value === 1) {
            return "badge bg-success"; // green
          }
          if (value === false || value === "false" || value === 0) {
            return "badge bg-danger"; // red
          }
          return "badge bg-secondary"; // default/unknown
        },
        transform: (value) => {
          if (value === true || value === "true" || value === 1)
            return "Active";
          if (value === false || value === "false" || value === 0)
            return "Inactive";
          return "Unknown";
        },
      },
    ],

    filters: [
      {
        key: "Type",
        label: "Scheme Type",
        width: "150px",
      },
      {
        key: "Status",
        label: "Status",
        width: "150px",
      },
    ],

    actions: {
      view: true,
      edit: true,
      delete: true,
    },
  };

  export const RoleManagement = {
    title: "Role Management",
    breadcrumbIcon: "ph-duotone ph-user",
    breadcrumbParent: "Resource",
    showDateFilter: false,
    idField: "id", // or "REF No" if that's your unique identifier
    defaultItemsPerPage: 10,
    defaultSortField: "created_at",
    defaultSortDirection: "desc",
    // numericFields: ["Amount"],
    
    columns: [
      {
        key: "id",
        label: "ID",
        type: "text",
        sortable: true
      },
      {
        key: "Name",
        label: "Name",
        type: "link",
        sortable: true
      }
      
      
      
     
    ],
    
    filters: [
     
    ],
    
    actions: {
      view: false,
      edit: true,
      delete: true
    }
  };

  export const CompanyManagement = {
    title: "Company Management",
    breadcrumbIcon: "ph-duotone ph-user",
    breadcrumbParent: "Resource",
    showDateFilter: false,
    idField: "id", // or "REF No" if that's your unique identifier
    defaultItemsPerPage: 10,
    defaultSortField: "created_at",
    defaultSortDirection: "desc",
    // numericFields: ["Amount"],
    
    columns: [
      {
        key: "id",
        label: "ID",
        type: "text",
        sortable: true
      },
      {
        key: "company_name",
        label: "company Name",
        type: "text",
        sortable: true
      }
      ,
      {
        key: "sort_name",
        label: "Sort Name",
        type: "text",
        sortable: true
      }
      ,
      {
        key: "website",
        label: "Website",
        type: "link",
        sortable: true
      }
     
      ,
      {
        key: "logo",
        label: "Logo",
        type: "image",
        sortable: true
      }
      ,
      {
        key: "sender_name",
        label: "Sender Name",
        type: "text",
        sortable: true
      }
      ,
      {
        key: "sms_user",
        label: "SMS User",
        type: "text",
        sortable: true
      },
      {
        key: "sms_password",
        label: "SMS Password",
        type: "text",
        sortable: true
      },
      {
        key: "sms_uti",
        label: "SMS UTI",
        type: "text",
        sortable: true
      },
      {
        key: "smtp_url",
        label: "SMTP URL",
        type: "text",
        sortable: true
      },
      {
        key: "sms_url",
        label: "SMS URL",
        type: "text",
        sortable: true
      },
      {
        key: "smtp_port",
        label: "SMTP PORT",
        type: "text",
        sortable: true
      },
      {
        key: "smtp_user",
        label: "SMTP USER",
        type: "text",
        sortable: true
      },
      {
        key: "smtp_password",
        label: "SMTP Password",
        type: "text",
        sortable: true
      },
      {
        key: "support_email",
        label: "Support Email",
        type: "text",
        sortable: true
      },
      {
        key: "support_phone",
        label: "Support Email",
        type: "text",
        sortable: true
      }


      
      
      
     
    ],
    
    filters: [
     
    ],
    
    actions: {
      view: false,
      edit: true,
      delete: true
    }
  };

  export const CommissionTypeManagement = {
    title: "Commission Type Management",
    breadcrumbIcon: "ph-duotone ph-user",
    breadcrumbParent: "Resource",
    showDateFilter: false,
    idField: "id", // or "REF No" if that's your unique identifier
    defaultItemsPerPage: 10,
    defaultSortField: "created_at",
    defaultSortDirection: "desc",
    // numericFields: ["Amount"],
    
    columns: [
      {
        key: "id",
        label: "ID",
        type: "text",
        sortable: true
      },
      {
        key: "Name",
        label: "Name",
        type: "link",
        sortable: true
      },
      
      {
        key: "Type",
        label: "Type",
        type: "badge",
        badgeClass: (value) => {
          const classes = {
            'plan': 'badge text-outline-danger',
            'scheme': 'badge text-outline-success',
           
          };
          return classes[value?.toLowerCase().replace(' ', '_')] || 'badge text-outline-secondary';
        },
        transform: (value) => value?.toUpperCase()
      },
      {
        key: "Status",
        label: "Status",
        type: "badge",
        badgeClass: (value) => {
          if (value === true || value === "true" || value === 1) {
            return "badge bg-success";   // green
          }
          if (value === false || value === "false" || value === 0) {
            return "badge bg-danger";    // red
          }
          return "badge bg-secondary";   // default/unknown
        },
        transform: (value) => {
          if (value === true || value === "true" || value === 1) return "Active";
          if (value === false || value === "false" || value === 0) return "Inactive";
          return "Unknown";
        },
      }
      
      
      
     
    ],
    
    filters: [
      {
        key: "Type",
        label: "Type",
        width: "150px"
      },
      {
        key: "Status",
        label: "Status",
        width: "150px"
      },
    ],
    
    actions: {
      view: true,
      edit: true,
      delete: true
    }
  };


  export const PSWalletSettlementManagement = {
    title: "Wallet Settlement",
    breadcrumbIcon: "ph-duotone ph-user",
    breadcrumbParent: "service",
    showDateFilter: false,
    idField: "id", // or "REF No" if that's your unique identifier
    defaultItemsPerPage: 10,
    defaultSortField: "created_at",
    defaultSortDirection: "desc",
    // numericFields: ["Amount"],
    
    columns: [
      {
        key: "id",
        label: "ID",
        type: "text",
        sortable: true
      },
      {
        key: "Name",
        label: "Name",
        type: "link",
        sortable: true
      },
      
      {
        key: "Type",
        label: "Type",
        type: "badge",
        badgeClass: (value) => {
          const classes = {
            'plan': 'badge text-outline-danger',
            'scheme': 'badge text-outline-success',
           
          };
          return classes[value?.toLowerCase().replace(' ', '_')] || 'badge text-outline-secondary';
        },
        transform: (value) => value?.toUpperCase()
      },
      {
        key: "Status",
        label: "Status",
        type: "badge",
        badgeClass: (value) => {
          if (value === true || value === "true" || value === 1) {
            return "badge bg-success";   // green
          }
          if (value === false || value === "false" || value === 0) {
            return "badge bg-danger";    // red
          }
          return "badge bg-secondary";   // default/unknown
        },
        transform: (value) => {
          if (value === true || value === "true" || value === 1) return "Active";
          if (value === false || value === "false" || value === 0) return "Inactive";
          return "Unknown";
        },
      }
      
      
      
     
    ],
    
    filters: [
      {
        key: "Type",
        label: "Type",
        width: "150px"
      },
      {
        key: "Status",
        label: "Status",
        width: "150px"
      },
    ],
    
    actions: {
      view: true,
      edit: true,
      delete: true
    }
  };


  export const CommissionManagement = {
    title: "Commission Management",
    breadcrumbIcon: "ph-duotone ph-user",
    breadcrumbParent: "Resource",
    showDateFilter: false,
    idField: "id", // or "REF No" if that's your unique identifier
    defaultItemsPerPage: 10,
    defaultSortField: "created_at",
    defaultSortDirection: "desc",
    // numericFields: ["Amount"],
    
    columns: [
      {
        key: "id",
        label: "ID",
        type: "text",
        sortable: true
      },
      {
        key: "com_type_id",
        label: "Commission Type",
        type: "text",
        sortable: true
      },
      {
        key: "scheme_id",
        label: "Scheme Name",
        type: "text",
        sortable: true
      },
      {
        key: "operator_id",
        label: "Operator",
        type: "text",
        sortable: true
      },
      {
        key: "white_label",
        label: "White Label",
        type: "text",
        sortable: true
      },
      {
        key: "super_distributor",
        label: "Super Distributor",
        type: "text",
        sortable: true
      },
      {
        key: "distributor",
        label: "Distributor",
        type: "text",
        sortable: true
      },
      {
        key: "retailer",
        label: "Retailer",
        type: "text",
        sortable: true
      },
      
      {
        key: "type",
        label: "Type",
        type: "badge",
        badgeClass: (value) => {
          const classes = {
            'fixed': 'badge text-outline-danger',
            'percent': 'badge text-outline-success',
           
          };
          return classes[value?.toLowerCase().replace(' ', '_')] || 'badge text-outline-secondary';
        },
        transform: (value) => value?.toUpperCase()
      }
      
      
      
     
    ],
    
    filters: [
      {
        key: "com_type_id",
        label: "Commission Type",
        width: "150px"
      },
      {
        key: "scheme_id",
        label: "Scheme",
        width: "150px"
      },
      {
        key: "operator_id",
        label: "Operator",
        width: "150px"
      },
      {
        key: "type",
        label: "Type",
        width: "150px"
      },
    ],
    
    actions: {
      view: false,
      edit: true,
      delete: true
    }
  };
  export const APIManagementData = {
    title: "API Management",
    breadcrumbIcon: "ph-duotone ph-user",
    breadcrumbParent: "Resource",
    showDateFilter: false,
    idField: "id", // or "REF No" if that's your unique identifier
    defaultItemsPerPage: 10,
    defaultSortField: "created_at",
    defaultSortDirection: "desc",
    // numericFields: ["Amount"],
    
    columns: [
      {
        key: "id",
        label: "ID",
        type: "text",
        sortable: true
      },
      {
        key: "Product Name",
        label: "Product Name",
        type: "text",
        sortable: true
      },
      {
        key: "Sort Name",
        label: "Sort Name",
        type: "text",
        sortable: true
      },
      {
        key: "URL",
        label: "URL",
        type: "text",
        sortable: true
      },
      {
        key: "API KEY",
        label: "API KEY",
        type: "text",
        sortable: true
      },
      {
        key: "User Name",
        label: "User Name",
        type: "text",
        sortable: true
      },
      {
        key: "Password",
        label: "Password",
        type: "text",
        sortable: true
      },
      {
        key: "code",
        label: "Code",
        type: "text",
        sortable: true
      },
      {
        key: "optional",
        label: "Optional",
        type: "text",
        sortable: true
      },
      
      {
        key: "Type",
        label: "Type",
        type: "text",
        sortable:true
      },
      
      {
        key: "Status",
        label: "Status",
        type: "badge",
        badgeClass: (value) => {
          if (value === true || value === "true" || value === 1) {
            return "badge bg-success";   // green
          }
          if (value === false || value === "false" || value === 0) {
            return "badge bg-danger";    // red
          }
          return "badge bg-secondary";   // default/unknown
        },
        transform: (value) => {
          if (value === true || value === "true" || value === 1) return "Active";
          if (value === false || value === "false" || value === 0) return "InActive";
          return "Unknown";
        },
      },
      
     
    ],
    
    filters: [
    
      {
        key: "Type",
        label: "Type",
        width: "150px"
      },
    ],
    
    actions: {
      view: true,
      edit: true,
      delete: true
    }
  };

  export const ChargeSlabManagerData = {
    title: "Charge Slab Management",
    breadcrumbIcon: "ph-duotone ph-user",
    breadcrumbParent: "Resource",
    showDateFilter: false,
    idField: "id", // or "REF No" if that's your unique identifier
    defaultItemsPerPage: 10,
    defaultSortField: "created_at",
    defaultSortDirection: "desc",
    // numericFields: ["Amount"],
    
    columns: [
      {
        key: "id",
        label: "ID",
        type: "text",
        sortable: true
      },
      {
        key: "Scheme Name",
        label: "Scheme Name",
        type: "text",
        sortable: true
      },
      
      {
        key: "Min Slab",
        label: "Minimum Slab",
        type: "text",
        sortable: true
      },
      {
        key: "Max Slab",
        label: "Maximum Slab",
        type: "text",
        sortable: true
      },
      {
        key: "Admin",
        label: "Admin",
        type: "text",
        sortable: true
      },
      {
        key: "White Label",
        label: "White Label",
        type: "text",
        sortable: true
      },
      {
        key: "Super Distributer",
        label: "Super Distributer",
        type: "text",
        sortable: true
      },
      {
        key: "Distributer",
        label: "Distributer",
        type: "text",
        sortable: true
      },
      {
        key: "Retailer",
        label: "Retailer",
        type: "text",
        sortable: true
      },

      {
        key: "Type",
        label: "Type",
        type: "badge",
        badgeClass: (value) => {
          if (value === "percent" || value === "percent" || value === 1) {
            return "badge bg-success";   // green
          }
          if (value === "fixed" || value === "fixed" || value === 0) {
            return "badge bg-danger";    // red
          }
          return "badge bg-secondary";   // default/unknown
        },
        transform: (value) => {
          if (value === "percent" || value === "percent" || value === 1) return "Percent";
          if (value === "fixed" || value === "fixed" || value === 0) return "Fixed";
          return "Unknown";
        },
      }
      
      
      
     
    ],
    
    filters: [
      {
        key: "Commission Type",
        label: "Commission Type",
        width: "150px"
      },
      {
        key: "Scheme Name",
        label: "Scheme Name",
        width: "150px"
      },
      {
        key: "Type",
        label: "Type",
        width: "150px"
      },
    ],
    
    actions: {
      view: false,
      edit: true,
      delete: true
    }
  };
  export const ProviderManagerData = {
    title: "Provider Management",
    breadcrumbIcon: "ph-duotone ph-user",
    breadcrumbParent: "Resource",
    showDateFilter: false,
    idField: "id", // or "REF No" if that's your unique identifier
    defaultItemsPerPage: 10,
    defaultSortField: "Transdate",
    defaultSortDirection: "desc",
    // numericFields: ["Amount"],
    
    columns: [
      {
        key: "id",
        label: "ID",
        type: "text",
        sortable: true
      },
      {
        key: "Name",
        label: "Name",
        type: "text",
        sortable: true
      },
      
      {
        key: "API 1",
        label: "API 1",
        type: "text",
        sortable: true
      },
      {
        key: "API 2",
        label: "API 2",
        type: "text",
        sortable: true
      },
      {
        key: "API 3",
        label: "API 3",
        type: "text",
        sortable: true
      },
      {
        key: "API 4",
        label: "API 4",
        type: "text",
        sortable: true
      },
      
      {
        key: "commission",
        label: "Commission",
        type: "text",
        sortable: true
      },
      {
        key: "API",
        label: "API",
        type: "text",
        sortable: true
      },

      {
        key: "Type",
        label: "Type",
        type: "text",
        sortable: true
      },
      {
        key: "Status",
        label: "Status",
        type: "badge",
        badgeClass: (value) => {
          if (value === true || value === "true" || value === 1) {
            return "badge bg-success";   // green
          }
          if (value === false || value === "false" || value === 0) {
            return "badge bg-danger";    // red
          }
          return "badge bg-secondary";   // default/unknown
        },
        transform: (value) => {
          if (value === true || value === "true" || value === 1) return "Active";
          if (value === false || value === "false" || value === 0) return "InActive";
          return "Unknown";
        },
      },
      {
        key: "Is Mandaotory",
        label: "Is Mandaotory",
        type: "badge",
        badgeClass: (value) => {
          if (value === true || value === "true" || value === 1) {
            return "badge bg-success";   // green
          }
          if (value === false || value === "false" || value === 0) {
            return "badge bg-danger";    // red
          }
          return "badge bg-secondary";   // default/unknown
        },
        transform: (value) => {
          if (value === true || value === "true" || value === 1) return "Active";
          if (value === false || value === "false" || value === 0) return "InActive";
          return "Unknown";
        },
      }
      
      
      
     
    ],
    
    filters: [
      {
        key: "Name",
        label: "Name",
        width: "150px"
      },
      {
        key: "Type",
        label: "Type",
        width: "150px"
      },
      {
        key: "commission",
        label: "Commission",
        width: "150px"
      },
      {
        key: "API",
        label: "API",
        width: "150px"
      },
    ],
    
    actions: {
      view: false,
      edit: true,
      delete: true
    }
  };
export const panCardReportsConfig = {
  title: "PAN Card Reports",
  breadcrumbIcon: "ph-duotone ph-identification-card",
  breadcrumbParent: "Reports",
  showDateFilter: true,
  idField: "id",
  defaultItemsPerPage: 10,
  defaultSortField: "id",
  defaultSortDirection: "desc",

  safe: (value) => (value ?? ""),

  numericFields: ["amount"],

  columns: [
    { key: "id", label: "ID", sortable: true },

    // ✅ Whitelabel / Master Distributor / Main Admin only (safe if missing)
    { key: "BCID", label: "BC ID" },
    { key: "BC Name", label: "BC Name" },

    { key: "pid", label: "PAN ID" },
    { key: "name", label: "Applicant Name", sortable: true },
    { key: "fathername", label: "Father Name" },

    { key: "category", label: "Category" },
    { key: "gender", label: "Gender" },
    { key: "dob", label: "DOB" },

    { key: "aadhar_num", label: "Aadhar No" },
    { key: "mobile", label: "Mobile" },
    { key: "email", label: "Email" },

    { key: "amount", label: "Amount", type: "currency" },

    {
      key: "status",
      label: "Status",
      type: "badge",
      sortable: true,
      badgeClass: (v) => {
        const s = v?.toLowerCase();
        if (["created", "initiated"].includes(s)) return "badge bg-warning";
        if (["accepted", "successfully completed"].includes(s))
          return "badge bg-success";
        if (["rejected", "failed"].includes(s)) return "badge bg-danger";
        return "badge bg-secondary";
      },
      transform: (v) => v?.toUpperCase(),
    },
  ],

  filters: [
    { key: "status", label: "Status", width: "150px" },
    { key: "category", label: "Category", width: "160px" },
    { key: "BC Name", label: "BC Name", width: "200px" },
  ],

  actions: {
    view: true, // ✅ ONLY ONE ACTION
    edit: false,
    delete: false,
  },
};
  

  export const UserBasedOperatorData = {
    title: "User Based Operator",
    fetchUrl: "https://pro.mokshiq.in/user_based_operator_action",
    columns: [
      { key: "id",         label: "ID"         },
      { key: "User",       label: "User"       },
      { key: "Provider",   label: "Provider"   },
      { key: "Min Amount", label: "Min Amount" },
      { key: "Max Amount", label: "Max Amount" },
      { key: "Optional",   label: "Optional"   },
      { key: "Created At", label: "Created"    },
    ],
  };
  
  export const MainOperatorRestrictionData = {
    title: "Main Operator Restriction",
    fetchUrl: "https://pro.mokshiq.in/main_operator_action",
    columns: [
      { key: "id",          label: "ID"          },
      { key: "Provider",    label: "Provider"    },
      { key: "User",        label: "User"        },
      { key: "Min Amount",  label: "Min Amount"  },
      { key: "Max Amount",  label: "Max Amount"  },
      { key: "Assigned By", label: "Assigned By" },
      { key: "Created At",  label: "Created"     },
    ],
  };

  export const PlanManagerData = {
    title: "Plan Manager",
    fetchUrl: "https://pro.mokshiq.in/plan_manager_action",
    columns: [
      { key: "id",                  label: "ID"               },
      { key: "Name",                label: "Name"             },
      { key: "Plan Type",           label: "Plan Type"        },
      { key: "Creation Charge",     label: "Creation Charge"  },
      { key: "Role Change Charge",  label: "Role Chg Charge"  },
      { key: "Created By",          label: "Created By"       },
      { key: "Created For",         label: "Created For"      },
      { key: "Status",              label: "Status"           },
      { key: "Created At",          label: "Created"          },
    ],
  };
  
  export const PlanServiceChargeData = {
    title: "Plan Service Charges",
    fetchUrl: "https://pro.mokshiq.in/plan_service_charge_action",
    columns: [
      { key: "id",         label: "ID"      },
      { key: "Plan",       label: "Plan"    },
      { key: "Service",    label: "Service" },
      { key: "Charge",     label: "Charge"  },
      { key: "Status",     label: "Status"  },
      { key: "Created At", label: "Created" },
    ],
  };
  
  export const RetailerPlanData = {
    title: "Retailer Plan Assignment",
    fetchUrl: "https://pro.mokshiq.in/retailer_plan_action",
    columns: [
      { key: "id",          label: "ID"          },
      { key: "Retailer",    label: "Retailer"    },
      { key: "Plan",        label: "Plan"        },
      { key: "Plan Type",   label: "Plan Type"   },
      { key: "Assigned By", label: "Assigned By" },
      { key: "Status",      label: "Status"      },
      { key: "Assigned At", label: "Assigned At" },
    ],
  };
  
  export const MainServiceData = {
    title: "Main Service List",
    fetchUrl: "https://pro.mokshiq.in/main_service_action",
    columns: [
      { key: "id",             label: "ID"             },
      { key: "Name",           label: "Name"           },
      { key: "Category",       label: "Category"       },
      { key: "Image",          label: "Image"          },
      { key: "Material Click", label: "Material Click" },
      { key: "Web URL",        label: "Web URL"        },
    ],
  };